<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M9.175 16.684a7.508 7.508 0 1 0 0-15.017 7.508 7.508 0 0 0 0 15.017m9.15-.892c-.275-.509-.858-.792-1.642-.792-.591 0-1.1.242-1.4.658s-.366.975-.183 1.534c.359 1.083.984 1.325 1.325 1.366.05.009.1.009.159.009.366 0 .933-.159 1.483-.984.442-.641.525-1.283.258-1.791"
	/>
</svg>
